// extracted by mini-css-extract-plugin
module.exports = {"SectionDateTime":"SectionDateTime___1pZ55"};